import http from '../../../Http';
import { ThemeContext } from '../../../Http';
import { useState, useContext, useRef, useEffect } from 'react';
import utils from '../../../utils';
import { Spin , Input, Button, Form, Row, Col, Select,Collapse} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import BitsEditorV2 from './BitsEditorV2';
import DateTimeEditor from './DateTimeEditor';
import HourMinuteEditorForUhomeSinglePhase from './HourMinuteEditorForUhomeSinglePhase';
import { useTranslation } from 'react-i18next';
import MeterDirectionDetection from "../RealtimeMonitorUhomeSinglePhaseCombination/MeterDirectionDetection";

const applyDef = (def, value) => {
    if (value == null || value == undefined) {
        return value;
    }

    if (def.RegisterType == "I16") {
        if (value > 0x7fff) {
            value -= 0xffff + 1;
        }
    } else if (def.RegisterType == "I32") {
        if (value > 0x7fffffff) {
            value -= 0xffffffff + 1;
        }
    }
    if (def.Scale) {
        value *= def.Scale;
        if (def.Scale < 1) {
            value = value.toFixed(def.Scale.toString().length-2 > 0 ? def.Scale.toString().length-2 : 0);
        }
    }
    return value;
}

const unApplyDef = (def, value) => {
    if (value == null || value == undefined) {
        return value;
    }

    if (def.Scale) {
        value = parseFloat(value);
        value /= def.Scale;
    }
    if (def.RegisterType == "I16") {
        if (value < 0) {
            value += 0xffff - 1;
        }
    } else if (def.RegisterType == "I32") {
        if (value < 0) {
            value += 0xffffffff - 1;
        }
    }
    
    return Math.round(value);
}

function UhomeSinglePhaseSetting({SN, SettingDefs}) {
    const { t, i18n } = useTranslation();
    const setTip = useContext(utils.tipContext);
    const session = useContext(ThemeContext);
   
    const [loading, setLoading] = useState(false);
    const [pendingValues, setPendingValues] = useState({});
    
    const refComfirmedValues = useRef({});
    const refPendingValues = useRef({});
    const refMeterDirectionDetection = useRef();


    const [form] = Form.useForm();

    const lang = i18n.language === "zh" ? "Chinese" : "English";

    const defMap = {};
    const defs = [];
    var subDefs = [];
    var lastCategory = null;
    var vs = {}
    for (var k in SettingDefs) {
        var def = SettingDefs[k];
        if (def.ReadWrite == "R" || def.RegisterAddress == "1234" || def.RegisterAddress == "1680") { 
            continue;
        }
        if ((def.RegisterType == "Bytes" || def.RegisterType == "[]byte") && def.MultiValue != null) {
            def.Value = JSON.parse(def.MultiValue);
        } else if (def.RegisterType == "ASCII") {
            def.Value = String.fromCharCode(...JSON.parse(def.MultiValue ?? "[]"));
            def.Value = def.Value.replaceAll("\0", "");
        }
        var address = def.RegisterAddressNumber;
        defMap[address] = def;
        if (lastCategory != def.Category) {
            subDefs = [];
            defs.push(subDefs);
            lastCategory = def.Category;
        }
        subDefs.push(def);
        //
        if (def.RegisterType != "ASCII" && def.RegisterType != "Bytes") {
            vs[address] = applyDef(def, def.Value);
        } else {
            vs[address] = def.Value;
        }
    }
    // if (Object.keys(vs).length != Object.keys(refComfirmedValues.current).length) {
    //     refComfirmedValues.current = {...vs};
    //     setTimeout(()=>setFormFieldsValue(vs), 50);
    // }

    useEffect(() => {
        refComfirmedValues.current = {...vs};
        refPendingValues.current = {};
        setFormFieldsValue(vs)
        setPendingValues({});
    }, [SN, SettingDefs]);

    const hex2Array = (hex) => {
        var arr = new Uint8Array(hex.match(/[\da-f]{2}/gi).map((h)=>parseInt(h, 16)));
        return Array.prototype.slice.call(new Uint8Array(arr.buffer )); 
    }

    const Array2hex = (arr) => {
        return arr.map((v) => v.toString(16).padStart(2, "0")).join("");
    }

    const setFormFieldsValue = (vs) => {
        vs = {...vs};
        form.setFieldsValue(vs)
    }

    const handleReset = (Category) => {
        var vs = {};
        var pvs = refPendingValues.current;
        var cvs = refComfirmedValues.current;
        var had = false;
        for (var k in pvs) {
            var def = defMap[k];
            if ( defMap.hasOwnProperty(k) && def.Category == Category) {
                had = true;
                vs[k] = cvs[k];
                delete pvs[k];
            }
        } 
        if (had) {
            // form.setFieldsValue(vs);
            setFormFieldsValue(vs);
            setPendingValues({...pvs});
        }
    }

    const handleRead = async (Category) => {
        //连续的地址成组读取，减少通讯次数
        var ps = [];
        for (var i in defs) {
            var fs = defs[i];
            if (fs[0].Category == Category) {
                var cs = [...fs];
                cs.sort((a, b) => a.RegisterAddressNumber - b.RegisterAddressNumber);
                
                var c = null;
                for (let def of cs) {
                    if (def.ReadWrite.indexOf("R") !== -1) {
                        if (c == null || c.Address + c.Count != def.RegisterAddressNumber || c.Address + c.Count + def.Count >32) {
                            c = {
                                Address: def.RegisterAddressNumber,
                                Count: def.RegisterNumber,
                            }
                            ps.push(c);
                        } else {
                            c.Count += def.RegisterNumber;
                        }
                    }
                }
                
                break;
            }
        }
        if (ps.length < 1) {
            return;
        }

        var pvs = refPendingValues.current; 
        for (var i in pvs) {
            var def = defMap[i];
            if (def.Category == Category) {
                setTip({ open: true, severity: "info", msg: t("There are pending changes") });
                return;
            }
        }

        setLoading(true);
        try {
            const resp = await http.postJSON("integrated-inverter-v2/setting/request", {
                SerialNumber: SN,
                RW: "R",
                InverterSettingParams: ps,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[Setting]", e);
                return null;
            });
            
            if (resp.data.SerialNumber != SN) {
                setTip({ open: true, severity: "error", msg: t("SerialNumber not match") });
                return;
            }

            var vs = {};
            var pvs = refPendingValues.current;
            for (var i in resp.data.InverterSettingParams) {
                var p = resp.data.InverterSettingParams[i];
                if (p.Result != 0) {
                    setTip({ open: true, severity: "error", msg: t("Read error") });
                    continue;
                }

                var data = p.Data;
                for (var addr = p.Address; addr < p.Address + p.Count; addr++) {
                    if (defMap.hasOwnProperty(addr)) {
                        var def = defMap[addr];
                        var idx = (addr - p.Address)*2;
                        var v = 0;
                       
                        if (def.RegisterType == "ASCII") {
                            v = String.fromCharCode(...data.slice(idx, idx + def.RegisterNumber*2));
                            v = v.replaceAll("\0", "");
                        } else if (def.RegisterType == "Bytes") {
                            v = data.slice(idx, idx + def.RegisterNumber*2);
                        } else {
                            for (var i=0; i<def.RegisterNumber; i++) {
                                // v += (data[idx + i*2]<<8) + data[idx + i*2 + 1];
                                v +=( (data[idx + i*2]<<8) + data[idx + i*2 + 1]) << (i*16);
                            }
    
                            v = applyDef(def, v);
                        }
                        vs[addr] = v;
                        delete(pvs[addr]);
                    }
                }
            }
            refComfirmedValues.current = {...refComfirmedValues.current, ...vs};
            setPendingValues(pvs);
            setFormFieldsValue(vs);

        } catch (e) {
            console.log("[Setting]", e);
            setTip({ open: true, severity: "error", msg: t("Read-Write error") });
        } finally {
            setLoading(false);
        }
    }

    const handleWrite = async (Category) => {
        var pvs = refPendingValues.current;
        if (Object.keys(pvs).length <= 0) {
            return;
        } 
        
        var ipvs = Object.keys(pvs);
        ipvs.sort((a, b) => a - b);

        var ps = [];
        var c = null;
        for (var i in ipvs) {
            var addr = ipvs[i];
            var def = defMap[addr];
            if (def.Category == Category) {
                if (c == null || c.Address + c.Count != def.RegisterAddressNumber || c.Address + c.Count + def.Count >32) {
                    c = {
                        Address: def.RegisterAddressNumber,
                        Count: def.RegisterNumber,
                        Data: [],
                    }
                    var v = pvs[addr];
                    var bs = [];
                    if (def.RegisterType == "ASCII") { 
                        for (let j = 0; j < v.length; j++) {
                            bs.push(v.charCodeAt(j));
                        }
                        if (bs.length < def.RegisterNumber*2) {
                            for (let j = bs.length; j < def.RegisterNumber*2; j++) {
                                bs.push(0);
                            }
                        }
                    } else if (def.RegisterType == "Bytes") {
                        bs.push(...v);
                    } else {
                        v = unApplyDef(def, pvs[addr]);
                        for (var j=0; j<def.RegisterNumber; j++) {
                            bs.push((v>>(8*(j*2+1))) & 0xff);
                            bs.push((v>>(8*(j*2))) & 0xff);
                        }
                    }
                    c.Data.push(...bs);
                    ps.push(c);
                } else {
                    c.Count += def.RegisterNumber;
                    var bs = [];
                    if (def.RegisterType == "ASCII") { 
                        for (let j = 0; j < v.length; j++) {
                            bs.push(v.charCodeAt(j));
                        }
                        if (bs.length < def.RegisterNumber*2) {
                            for (let j = bs.length; j < def.RegisterNumber*2; j++) {
                                bs.push(0);
                            }
                        }
                    } else {
                        var v = unApplyDef(def, pvs[addr]);
                        for (var j=0; j<def.RegisterNumber; j++) {
                            bs.push((v>>(8*(j*2+1))) & 0xff);
                            bs.push((v>>(8*(j*2))) & 0xff);
                        }
                    }
                    c.Data.push(...bs);
                }
            }
        }

        if (ps.length < 1) {
            return;
        }

        setLoading(true);
        try {
            const resp= await http.postJSON("integrated-inverter-v2/setting/request", {
                SerialNumber: SN,
                RW: "W",
                InverterSettingParams: ps,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[Setting]", e);
                return null;
            });
            
            if (resp.data.SerialNumber != SN) {
                setTip({ open: true, severity: "error", msg: t("SerialNumber not match") });
                return;
            }

            var vs = {};
            for (var i in resp.data.InverterSettingParams) {
                var p = resp.data.InverterSettingParams[i];
                if (p.Result != 0) {
                    setTip({ open: true, severity: "error", msg: t("Write error") });
                    continue;
                }

                for (var addr = p.Address; addr < p.Address + p.Count; addr++) {
                    if (defMap.hasOwnProperty(addr) && pvs.hasOwnProperty(addr)) {
                        vs[addr] = pvs[addr];
                        delete(pvs[addr]);
                    }
                }
            }
            setPendingValues(pvs)
            refComfirmedValues.current = {...refComfirmedValues.current, ...vs};
            setFormFieldsValue(vs);

        } catch (e) {
            console.log("[Setting]", e);
            setTip({ open: true, severity: "error", msg: t("Read-Write error") });
        } finally {
            setLoading(false);
        }
    }

    const handleReadSingle = async (RegisterAddressNumber) => {
        const address = parseInt(RegisterAddressNumber);

        var def = defMap[address];
        if (def == null) {
            return;
        }

        setLoading(true);
        try {
            const resp = await http.postJSON("integrated-inverter-v2/setting/request", {
                SerialNumber: SN,
                RW: "R",
                InverterSettingParams: [{
                    Address: address,
                    Count: def.RegisterNumber,
                }],
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[Setting]", e);
                return null;
            });
            
            if (resp.data.SerialNumber != SN) {
                setTip({ open: true, severity: "error", msg: t("SerialNumber not match") });
                return;
            }

            var vs = {};
            var p = resp.data.InverterSettingParams[0];
            if (p.Result != 0) {
                setTip({ open: true, severity: "error", msg: t("Read error") });
                return;
            }

            var data = p.Data;
            var pvs = refPendingValues.current;
            for (var addr = p.Address; addr < p.Address + p.Count; addr++) {
                if (defMap.hasOwnProperty(addr)) {
                    var def = defMap[addr];
                    var idx = (addr - p.Address)*2;
                    var v = 0;
                    
                    if (def.RegisterType == "ASCII") {
                        v = String.fromCharCode(...data.slice(idx, idx + def.RegisterNumber*2));
                        v = v.replaceAll("\0", "");
                    } else if (def.RegisterType == "Bytes") {
                        v = data.slice(idx, idx + def.RegisterNumber*2);
                    } else {
                        for (var i=0; i<def.RegisterNumber; i++) {
                            v +=( (data[idx + i*2]<<8) + data[idx + i*2 + 1]) << (i*16);
                        }
    
                        v = applyDef(def, v);
                    }
                    vs[addr] = v;
                    delete(pvs[addr]);
                }
            }
        
            refComfirmedValues.current = {...refComfirmedValues.current, ...vs};
            setPendingValues(pvs);
            setFormFieldsValue(vs);

        } catch (e) {
            console.log("[Setting]", e);
            setTip({ open: true, severity: "error", msg: t("Read-Write error") });
        } finally {
            setLoading(false);
        }
        
    }

    const handleWriteSingle = async (RegisterAddressNumber) => {
        const address = parseInt(RegisterAddressNumber);
        var def = defMap[address];
        if (def == null) {
            return;
        }

        var pvs = refPendingValues.current;

        var v = pvs[address];
        if (v === null || v === undefined) {
            v = refComfirmedValues.current[address];
            if (v === null || v === undefined) {
                return;
            }
        }

        var bs = [];
        if (def.RegisterType == "ASCII") { 
            for (let i = 0; i < v.length; i++) {
                bs.push(v.charCodeAt(i));
            }
            if (bs.length < def.RegisterNumber*2) {
                for (let i = bs.length; i < def.RegisterNumber*2; i++) {
                    bs.push(0);
                }
            }
        } else if (def.RegisterType == "Bytes") {
            bs.push(...v);
        } else {
            v = unApplyDef(def, v);
            for (var i=0; i<def.RegisterNumber; i++) {
                bs.push((v>>(8*(i*2+1))) & 0xff);
                bs.push((v>>(8*(i*2))) & 0xff);
            }
        }

        setLoading(true);
        try {
            const resp= await http.postJSON("integrated-inverter-v2/setting/request", {
                SerialNumber: SN,
                RW: "W",
                InverterSettingParams: [{
                    Address: address,
                    Count: def.RegisterNumber,
                    Data: bs,
                }],
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[Setting]", e);
                return null;
            });
            
            if (resp.data.SerialNumber != SN) {
                setTip({ open: true, severity: "error", msg: t("SerialNumber not match") });
                return;
            }

            var vs = {};
            for (var i in resp.data.InverterSettingParams) {
                var p = resp.data.InverterSettingParams[i];
                if (p.Result != 0) {
                    setTip({ open: true, severity: "error", msg: t("Write error") });
                    continue;
                }

                for (var addr = p.Address; addr < p.Address + p.Count; addr++) {
                    if (defMap.hasOwnProperty(addr) && pvs.hasOwnProperty(addr)) {
                        vs[addr] = pvs[addr];
                        delete(pvs[addr]);
                    }
                }
            }
            setPendingValues(pvs)
            refComfirmedValues.current = {...refComfirmedValues.current, ...vs};
            setFormFieldsValue(vs);

        } catch (e) {
            console.log("[Setting]", e);
            setTip({ open: true, severity: "error", msg: t("Read-Write error") });
        } finally {
            setLoading(false);
        }
    }

    const handleDo = async (RegisterAddressNumber) => {
        const address = parseInt(RegisterAddressNumber);
        var def = defMap[address];
        if (def == null) {
            return;
        }

        var v = def.Ranges.replaceAll("[", "").replaceAll("]", "");
        var v = parseInt(v);
        var bs = [];
        
        v = unApplyDef(def, v);
        for (var i=def.RegisterNumber-1; i>=0; i--) {
            bs.push((v>>(8*(i*2+1))) & 0xff);
            bs.push((v>>(8*(i*2))) & 0xff);
        }
        

        setLoading(true);
        try {
            const resp= await http.postJSON("integrated-inverter-v2/setting/request", {
                SerialNumber: SN,
                RW: "W",
                InverterSettingParams: [{
                    Address: address,
                    Count: def.RegisterNumber,
                    Data: bs,
                }],
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[Setting]", e);
                return null;
            });
            
            if (resp.data.SerialNumber != SN) {
                setTip({ open: true, severity: "error", msg: t("SerialNumber not match") });
                return;
            }

            var vs = {};
            for (var i in resp.data.InverterSettingParams) {
                var p = resp.data.InverterSettingParams[i];
                if (p.Result != 0) {
                    setTip({ open: true, severity: "error", msg: t("Do error") });
                    continue;
                }

                setTip({ open: true, severity: "success", msg: t("Do success") });

            }

        } catch (e) {
            console.log("[Setting]", e);
            setTip({ open: true, severity: "error", msg: t("Read-Write error") });
        } finally {
            setLoading(false);
        }
    }

    const handleMeterDirectionDetection = () => {
        refMeterDirectionDetection.current.doMeterDirectionDetection();
    }

    const editor_onchange_handler = (props) => {
        console.log("[Setting]", props);
        var cvs = refComfirmedValues.current;
        var pvs = refPendingValues.current;
        var pvs_changed = false;
        for (var k in props) {
            var v = props[k];
            
            if (cvs[k] == v) {
                if (pvs.hasOwnProperty(k)) {
                    delete pvs[k];
                    pvs_changed = true;
                }
            } else {
                pvs[k] = v;
                pvs_changed = true;
            }
            
        }
        if (pvs_changed) {
            setPendingValues({...pvs});
        }
    } 

    const showItems = [];
    var elems = [];
    const toRow = (cells, rows) => {
        var cols = [];
        for (var i in cells) {
            var cell = cells[i];
            cols.push(<Col 
                key={i}
                span={24}
            >
                {cell}
            </Col>)
        }
        rows.push(<Row>
            {cols}
        </Row>); 
    }
    if (SettingDefs == null) {
        elems.push(t("waiting..."));
    } else {
        for (var i in defs) {
            subDefs = defs[i];
            var rows = [];
            var cells = []; 
            var showCollapse = false;
            for (var j in subDefs) {
                def = subDefs[j];

                //非admin账户只显示指定项
                if(session != null && session.IsAdmin != 1 && !showItems.includes(def['RegisterAddress'])) {
                    continue
                }

                showCollapse = true;

                if (cells.length >= 1) {
                    toRow(cells, rows);
                    cells = [];
                }
                
                var editor = null;
                if (def.ReadWrite == "W" && def.Ranges && def.Ranges.indexOf("-") < 0) {
                    editor = <Button 
                        type="primary" 
                        size="medium"
                        shape="round"
                        style={{
                            backgroundColor: "#40a9ff",
                            color: "white",
                            textTransform: "none"

                        }}
                        data-register-address={def.RegisterAddressNumber} 
                        onClick={(e) => {handleDo(e.currentTarget.getAttribute("data-register-address")); e.stopPropagation()}}
                    >{t("Do")}</Button>;
                } else {
                    if (def.Format == "DateTime") {
                        editor = <DateTimeEditor
                            key={def.RegisterAddressNumber}
                            pendingValue={pendingValues[def.RegisterAddressNumber]}
                        />
                    } else if (def.Format == "HourMinute") {
                        editor = <HourMinuteEditorForUhomeSinglePhase
                            key={def.RegisterAddressNumber}
                            pendingValue={pendingValues[def.RegisterAddressNumber]}
                        />
                    } else if (def.Format != null) {
                        var fmt = JSON.parse(def.Format);
                        if (Array.isArray(fmt)) {
                            let intls = {};
                            for (var k in def.Intls2) {
                                let kk = k.substring(k.indexOf(":", -1)+1);
                                intls[kk] = def.Intls2[k];
                            }
                            if (fmt[0].Bits) {
                                editor = <BitsEditorV2
                                    key={def.RegisterAddressNumber}
                                    BitsDef={fmt}
                                    pendingValue={pendingValues[def.RegisterAddressNumber]}
                                    Intls={intls}
                                />
                            } else if (fmt[0].Bytes) {
                                //
                            }
                        }
                    } else if (def.Enums) {
                        if (def.Enums[0] == "{") {
                            var Enums = JSON.parse(def.Enums);
                            // editor = (<BitsEditor key="BitEditor" BitsDef={Enums} pendingValue={pendingValues[def.RegisterAddressNumber]}></BitsEditor>);
                        } else if (def.Enums[0] == "[") {
                            //
                        } else {
                            var Enums = def.Enums.split(";");
                            var opts = [];
                            for (var k in Enums) {
                                var vn = Enums[k].split(":");
                                var kk = def.Remark.substring(6)+":"+vn[1].trim()+"-"+lang;
                                opts.push(<Select.Option
                                    key={(vn[0].trim())}
                                    value={parseInt(vn[0].trim())}
                                >{def.Intls2[kk] ?? t(vn[1])}</Select.Option>);
                            }
                            editor = <Select
                                disabled={def.ReadWrite == "R" ? true : false}
                                suffixIcon={pendingValues.hasOwnProperty(def.RegisterAddressNumber) ? <EditOutlined /> : undefined}
                            >{opts}</Select>;
                        }
                    } else {
                        editor = <Input  
                            disabled={def.ReadWrite == "R" ? true : false}
                            suffix={pendingValues.hasOwnProperty(def.RegisterAddressNumber) ? <EditOutlined /> : <span />}
                            placeholder={def["Ranges"] ?? ""}
                            name={def.RegisterAddressNumber}
                            id={def.RegisterAddressNumber}
                            // precision={def.Scale ? def.Scale.toString().length-2 : undefined} 
                        />;
                    }
                }
                cells.push(<div style={{display:"flex"}}>
                    <Form.Item
                        style={{width: "60%"}}
                        key={def.RegisterAddress}
                        label={def.RegisterAddressNumber==0xa03a ? t("Date Time") : (t(def.Intls[lang])+(def.Unit?` (${def.Unit})`:t("")))}
                        name={def.RegisterAddressNumber}
                        hidden={[0xa03b,0xa03c].indexOf(def.RegisterAddressNumber)>-1 ? true : false}
                        rules={def.RegisterAddressNumber==0xa03f ? [{
                            validator: (_, value) => {
                                const v = parseInt(value);
                                if (isNaN(value) || v < 0 || v > 1600) {
                                    return Promise.reject(t('Value must be between 0 and 1600'));
                                } else {
                                    return Promise.resolve();
                                }
                            }
                        }] : null}
                    >
                        {editor}
                    </Form.Item>
                    {def.ReadWrite.indexOf("R") == -1 ? "" : <><div style={{width: 8}}></div><Button 
                            type="primary" 
                            size="small"
                            shape="round"
                            style={{
                                backgroundColor: "#40a9ff",
                                color: "white",
                                textTransform: "none",
                                border: "1px solid #eee"

                            }}
                            data-registeraddressnumber={def.RegisterAddressNumber} 
                            onClick={(e) => {handleReadSingle(e.currentTarget.getAttribute("data-registeraddressnumber")); e.stopPropagation()}}
                        >{t("Read")}</Button></>}
                        {def.ReadWrite.indexOf("W") == -1 || (def.Ranges && def.Ranges.indexOf("-") < 0) ? "" : <><div style={{width: 8}}></div><Button 
                            type="primary" 
                            size="small"
                            shape="round"
                            style={{
                                backgroundColor: "#40a9ff",
                                color: "white",
                                textTransform: "none",
                                border: "1px solid #eee"

                            }}
                            data-registeraddressnumber={def.RegisterAddressNumber} 
                            onClick={(e) => {handleWriteSingle(e.currentTarget.getAttribute("data-registeraddressnumber")); e.stopPropagation()}}
                        >{t("Write")}</Button><div style={{width: 5}}></div></>}
                        {def.RegisterAddressNumber==0x1406?<Button size='small' shape='round' style={{
                            marginLeft: 20,
                            backgroundColor: "#40a9ff",
                            color: "white",
                            textTransform: "none",
                            border: "1px solid #eee"

                        }} onClick={handleMeterDirectionDetection}>{t("Meter Direction Detection")}</Button>:null}
                </div>);
            }
            if (cells.length > 0) {
                toRow(cells, rows);
            }
            showCollapse && elems.push(<Collapse.Panel
                key={i}
                header={<span style={{fontWeight: "bold"}}>{t(subDefs[0].Category)}</span>}
                extra={subDefs[0].Category == "Setting-Instruction" ? "" : (<div key={i} style={{display:"flex"}}>
                    <Button 
                        type="primary" 
                        size="medium"
                        shape="round"
                        style={{
                            backgroundColor: "white",
                            color: "#888",
                            textTransform: "none",
                            border: "1px solid #eee"

                        }}
                        data-category={subDefs[0].Category} 
                        onClick={(e) => {handleReset(e.currentTarget.getAttribute("data-category")); e.stopPropagation()}}
                    >{t("Reset")}</Button>
                    <div style={{ width: "30px" }}></div>
                    <Button 
                        type="primary" 
                        size="medium"
                        shape="round"
                        style={{
                            backgroundColor: "#40a9ff",
                            color: "white",
                            textTransform: "none"

                        }}
                        data-category={subDefs[0].Category} 
                        onClick={(e) => {e.stopPropagation(); handleRead(e.currentTarget.getAttribute("data-category")); }}
                    >{t("Read")}</Button>
                    <div style={{ width: "15px" }}></div>
                    <Button 
                        type="primary" 
                        size="medium"
                        shape="round"
                        style={{
                            backgroundColor: "#40a9ff",
                            color: "white",
                            textTransform: "none"

                        }} 
                        data-category={subDefs[0].Category} 
                        onClick={(e) => {handleWrite(e.currentTarget.getAttribute("data-category")); e.stopPropagation()}}
                    >{t("Write")}</Button>
                </div>)}
            >
                {rows}
            </Collapse.Panel>);
        }
    }
    

    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
            }}
        >{SettingDefs==null ? "waiting..." : (<>
            <div style={{
                flex: '1 1 auto',
                backgroundColor: 'white',
                overflowY: "scroll"
            }}>
                <Form
                    form={form}
                    labelCol={{ span: 12 }}
                    wrapperCol={{ span: 8 }}
                    layout="horizontal"
                    size="small"
                    style={{
                        width: "100%",
                    }}
                    onValuesChange={editor_onchange_handler}
                >
                    <Collapse defaultActiveKey={['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19']}>{elems}</Collapse>
                </Form>
                
            </div>
            {loading && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                }}>
                    <Spin size="large" />
                </div>
            )}
        </>)}
        <MeterDirectionDetection ref={refMeterDirectionDetection} sns={[SN]} />;
        </div>
    );
}

export default UhomeSinglePhaseSetting;